import { EMAIL_KIND_MOUNTING_COMPLETE, type Project } from '@/api/client';
import { ProjectEmailModal } from './ProjectEmailModal';

export type MountingCompleteEmailModalMode = 'status_transition' | 'email_only';

export interface MountingCompleteEmailModalProps {
  open: boolean;
  onClose: () => void;
  project: Project;
  mode: MountingCompleteEmailModalMode;
  intendedState?: string;
}

export function MountingCompleteEmailModal({
  open,
  onClose,
  project,
  mode,
  intendedState,
}: MountingCompleteEmailModalProps) {
  return (
    <ProjectEmailModal
      open={open}
      onClose={onClose}
      project={project}
      emailKind={EMAIL_KIND_MOUNTING_COMPLETE}
      modalTitle={`Монтаж завершён: ${project.name ?? 'Проект'}`}
      requireNewState={mode === 'status_transition'}
      newStateWhenSaving={mode === 'status_transition' ? intendedState : undefined}
    />
  );
}
